import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardContent, ListItem, ListItemAvatar, ListItemText, Typography, makeStyles,
} from '@material-ui/core';
import MyAvatar from '../../components/widgets/avatar/MyAvatar';
import { MyFormattedDateTime } from '../../components/intl';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(1),
  },
}));

const StatusCard = ({
  photoURL,
  username,
  timestamp,
  message,
  comments,
}) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardContent>
        <ListItem>
          <ListItemAvatar>
            <MyAvatar
              src={photoURL}
              alt={username}
              name={username}
            />
          </ListItemAvatar>
          <ListItemText
            primary={username}
            secondary={(<MyFormattedDateTime value={timestamp} />)}
          />
        </ListItem>
        <Typography variant="body1">
          {message}
        </Typography>
        <Typography variant="caption">
          {comments}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatusCard;
